import { Popper } from "@mui/material";

export function LineSelectPopper(props) {
  return (
    <Popper sx={{ maxWidth: "30rem" }} placement="bottom-start" {...props} />
  );
}
